var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Control/Close/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M4.10349 3.39639C3.90823 3.20112 3.59165 3.20112 3.39639 3.39639C3.20112 3.59165 3.20112 3.90823 3.39639 4.10349L9.29291 10L3.39655 15.8964C3.20129 16.0916 3.20129 16.4082 3.39655 16.6035C3.59181 16.7988 3.90839 16.7988 4.10365 16.6035L10 10.7071L15.8964 16.6035C16.0916 16.7988 16.4082 16.7988 16.6035 16.6035C16.7988 16.4082 16.7988 16.0916 16.6035 15.8964L10.7071 10L16.6037 4.10349C16.7989 3.90823 16.7989 3.59165 16.6037 3.39639C16.4084 3.20112 16.0918 3.20112 15.8965 3.39639L10 9.29291L4.10349 3.39639Z",
    fill: "#5B5C5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNone);
export default __webpack_public_path__ + "static/media/CloseNone.a12df1d8e49a2ec75cd429b1368182f8.svg";
export { ForwardRef as ReactComponent };